import { rest } from "src/common/rest";
import { apiExtRegUrl } from "src/common/apiUrl";
import { ZUid } from "src/types/zUid";
import { zBsRegSettings, ZBsRegSettings } from "./bsRegistration.types";

export const bsRegSettingsUrl = (id: ZUid) => apiExtRegUrl(`/settings/${id}`);

export const loadBsRegSettings = async (id: ZUid): Promise<ZBsRegSettings> => {
  const resp = await rest.get(bsRegSettingsUrl(id));
  return zBsRegSettings.parse(resp.data);
};

export const saveBsRegSettings = async (id: ZUid, settings: ZBsRegSettings) => {
  await rest.post(bsRegSettingsUrl(id), settings);
};
